// https://github.com/SamsungInternet/support/issues/56
// https://github.com/SamsungInternet/support/issues/56#issuecomment-412439545
Function.prototype.ToString = function () { return this.toString(); } // eslint-disable-line
